import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, UserPlus, CalendarCheck, BarChart2 } from "lucide-react";

export default function PracticeMetrics({
  totalPatients,
  newPatientsCount,
  appointmentsTodayCount,
}) {
  const metrics = [
    {
      icon: Users,
      value: totalPatients,
      label: "Total Patients",
      description: "All time",
      color: "text-purple-600",
    },
    {
      icon: UserPlus,
      value: newPatientsCount,
      label: "New Patients",
      description: "This month",
      color: "text-blue-600",
    },
    {
      icon: CalendarCheck,
      value: appointmentsTodayCount,
      label: "Appointments",
      description: "Today",
      color: "text-green-600",
    },
  ];

  return (
    <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60 shadow-xl">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-slate-900">
          <BarChart2 className="w-5 h-5 text-indigo-600" />
          Practice Metrics
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-6">
          {metrics.map((metric) => (
            <div
              key={metric.label}
              className="flex flex-col items-center text-center p-3 bg-slate-50/60 rounded-lg"
            >
              <metric.icon className={`w-8 h-8 mb-2 ${metric.color}`} />
              <p className="text-2xl font-bold text-slate-900">
                {metric.value}
              </p>
              <p className="text-sm font-medium text-slate-700">
                {metric.label}
              </p>
              <p className="text-xs text-slate-500">{metric.description}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
